"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CADENCE_SCH_UNIT_TO_MM = void 0;
exports.modelNameOf = modelNameOf;
exports.viewOf = viewOf;
exports.isOffpageConnectorModelRef = isOffpageConnectorModelRef;
exports.pinNumberFromTerminal = pinNumberFromTerminal;
exports.bboxToMm = bboxToMm;
exports.entityItems = entityItems;
exports.iterateComponentInstances = iterateComponentInstances;
exports.iteratePowerSymbols = iteratePowerSymbols;
exports.iterateNetStubs = iterateNetStubs;
exports.terminalHotpointMm = terminalHotpointMm;
exports.iterateTerminals = iterateTerminals;
exports.iterateVisualLabels = iterateVisualLabels;
exports.iterateWireBundles = iterateWireBundles;
exports.iterateWireSegments = iterateWireSegments;
exports.parseTransformMatrix = parseTransformMatrix;
exports.parseRotationDeg = parseRotationDeg;
const helpers_1 = require("../../parsers/ascii/decode/helpers");
const decode_tc31_visual_label_1 = require("../../parsers/ascii/decode/decoders/decode-tc31-visual-label");
exports.CADENCE_SCH_UNIT_TO_MM = 0.000_254;
function modelNameOf(modelRef) {
    if (modelRef === null || modelRef.length === 0) {
        return '';
    }
    const idx = modelRef.indexOf('##');
    const raw = idx < 0 ? modelRef : modelRef.slice(0, idx);
    return (0, helpers_1.decodeCadenceName)(raw);
}
function viewOf(modelRef) {
    if (modelRef === null) {
        return '';
    }
    const sepIdx = modelRef.indexOf('##');
    if (sepIdx < 0) {
        return '';
    }
    const after = modelRef.slice(sepIdx + 2);
    const colonIdx = after.indexOf(':');
    return colonIdx < 0 ? after : after.slice(0, colonIdx);
}
function isOffpageConnectorModelRef(modelRef) {
    return modelRef !== null && /^offpage##sym_[123](:|$)/.test(modelRef);
}
function pinNumberFromTerminal(terminal) {
    if (terminal.subReference === null) {
        return null;
    }
    const stripped = terminal.subReference.startsWith('19:') ? terminal.subReference.slice(3) : terminal.subReference;
    const idx = stripped.indexOf('!~');
    return idx < 0 ? stripped : stripped.slice(0, idx);
}
function bboxToMm(bbox) {
    if (bbox === null) {
        return null;
    }
    return {
        x1: bbox.x1 * exports.CADENCE_SCH_UNIT_TO_MM,
        y1: bbox.y1 * exports.CADENCE_SCH_UNIT_TO_MM,
        x2: bbox.x2 * exports.CADENCE_SCH_UNIT_TO_MM,
        y2: bbox.y2 * exports.CADENCE_SCH_UNIT_TO_MM,
    };
}
function* entityItems(slot, expectedKind) {
    if (slot === null || !('items' in slot)) {
        return;
    }
    for (const item of slot.items) {
        if ('kind' in item && item.kind === expectedKind) {
            yield item;
        }
    }
}
function iterateComponentInstances(body) {
    return entityItems(body.slots.componentInstances, 'component-instance');
}
function iteratePowerSymbols(body) {
    return entityItems(body.slots.powerSymbols, 'power-symbol');
}
function iterateNetStubs(body) {
    return entityItems(body.slots.netStubs, 'net-stub');
}
function terminalHotpointMm(terminal) {
    const c = terminal.positionContainer;
    if (c === null) {
        return null;
    }
    const pos = (0, decode_tc31_visual_label_1.readCadencePosition)(c);
    if (pos === null || (pos.x === 0 && pos.y === 0)) {
        return null;
    }
    return { x: pos.x * exports.CADENCE_SCH_UNIT_TO_MM, y: pos.y * exports.CADENCE_SCH_UNIT_TO_MM };
}
function iterateTerminals(instance) {
    return entityItems(instance.terminals, 'terminal');
}
function iterateVisualLabels(instance) {
    return entityItems(instance.visualLabels, 'visual-label');
}
function iterateWireBundles(stub) {
    return entityItems(stub.wireBundles, 'wire-bundle');
}
function iterateWireSegments(bundle) {
    return entityItems(bundle.segments, 'wire-segment');
}
function parseTransformMatrix(transform) {
    if (transform === null || transform.length === 0) {
        return null;
    }
    const parts = transform.split(',').map((s) => parseFloat(s.trim()));
    if (parts.length < 9 || parts.some((n) => !Number.isFinite(n))) {
        return null;
    }
    return parts.slice(0, 9);
}
function parseRotationDeg(rotation) {
    if (rotation === null) {
        return null;
    }
    const n = parseFloat(rotation);
    return Number.isFinite(n) ? n : null;
}
//# sourceMappingURL=AllegroRecordHelpers.js.map